<template>
  <div class="height-tracker flex-grow-1" ref="container">
    <slot v-if="height" :height="height"/>
  </div>
</template>

<script>
  import $ from 'jquery'
  import throttle from 'lodash/throttle'

  export default {
    name: 'HeightTracker',
    data () {
      return {
        height: null,
        interval: null,
      }
    },
    mounted () {
      this.updateHeight()
      $(window).on('resize', this.throttledUpdateHeight)
      this.interval = setInterval(this.throttledUpdateHeight, 1500)
    },
    methods: {
      updateHeight () {
        if (this.$refs.container) {
          this.height = this.$refs.container.clientHeight
        }
      },
      throttledUpdateHeight: throttle(function () {
        this.updateHeight()
      }, 300),
    },
    beforeDestroy () {
      $(window).off('resize', this.throttledUpdateHeight)
      this.interval && clearInterval(this.interval)
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/height-tracker.vue